export const isMac = () => window && /^Mac/i.test(window.navigator.platform)
